import { httpClient } from '@/infrastructure/api/httpClient';
import type { CatalogRepository } from '@/domain/port/CatalogRepository';
import type { Category } from '@/domain/model/Category';
import type { Subcategory } from '@/domain/model/Subcategory';
import type { Chapter } from '@/domain/model/Chapter';

export class CatalogApiAdapter implements CatalogRepository {
  async getCategories(): Promise<Category[]> {
    const response = await httpClient.get<Category[]>('/categories');
    return response.data;
  }

  async getCategory(id: string): Promise<Category> {
    const response = await httpClient.get<Category>(`/categories/${id}`);
    return response.data;
  }

  async getSubcategory(id: string): Promise<Subcategory> {
    const response = await httpClient.get<Subcategory>(`/subcategories/${id}`);
    return response.data;
  }

  async getChaptersBySubcategory(subcategoryId: string): Promise<Chapter[]> {
    const response = await httpClient.get<Chapter[]>(`/chapters/subcategory/${subcategoryId}`);
    return response.data;
  }
}
